"use client";

import { Globe, Microscope, Handshake } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Partnervalue() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const promises = [{
    icon: Globe,
    stickerBg: "bg-blue-50",
    title: "Global Partnerships",
    metric: "Global Partnerships",
    description: "Connecting trusted partners across global healthcare.\n\n\nWe build meaningful relationships with manufacturers, healthcare professionals, distributors, and business partners to create sustainable international collaborations.\n\n"
  }, {
    icon: Microscope,
    stickerBg: "bg-teal-50",
    title: "Professional Evaluation",
    metric: "Professional Evaluation",
    description: "Turning information into confident decisions.\n\nWe provide structured product evaluations based on clinical applications, market insights, scientific evidence, and commercial potential."
  }, {
    icon: Handshake,
    stickerBg: "bg-background",
    title: "Innovation Discovery\n",
    metric: "Innovation Discovery",
    description: "Exploring tomorrow's healthcare solutions.\nWe continuously identify innovative technologies that address evolving clinical needs and emerging healthcare trends.\n"
  }];
  return <section data-section-id="1395" id="partnervalue" className="relative bg-slate-50 py-24 md:py-32 overflow-hidden">
      <div ref={ref} className={`mx-auto max-w-7xl px-6 md:px-12 transition-smooth ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="flex items-center gap-3 mb-6">
              <span className="font-default uppercase tracking-wide text-primary text-xs">§ OUR VALUE · GLOBAL PARTNERSHIPs</span>
              <span className="inline-block w-3 h-3 rounded-lg bg-teal-600" />
            </div>

            <h2 className="font-default font-bold text-blue-950 mb-6" style={{
            fontSize: "var(--text-6xl)",
            lineHeight: "var(--line-height-heading)"
          }}>Your Trusted Partner in <span className="relative inline-block text-teal-700" data-ast-id="f:/src/pages/Home/sections/Partnervalue.tsx|sig:bfdgle" data-ast-start="2450" data-ast-end="3407" contenteditable="false" style={{}}>Global Healthcare<svg className="absolute -inset-2 w-[calc(100%+1rem)] h-[calc(100%+1rem)] pointer-events-none -rotate-[2deg]" viewBox="0 0 120 60" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="none" data-ast-id="f:/src/pages/Home/sections/Partnervalue.tsx|sig:t1vn7b" data-ast-start="2632" data-ast-end="3400"><path d="M 60 6 C 90 6 114 16 114 30 C 114 46 88 54 60 54 C 30 54 6 46 6 30 C 6 16 28 8 60 6 Z" stroke="#0d9488" stroke-width="3" stroke-linecap="round" fill="none" stroke-dasharray="400" stroke-dashoffset="0" data-ast-id="f:/src/pages/Home/sections/Partnervalue.tsx|sig:8yap1f" data-ast-start="2967" data-ast-end="3394" style={{
                  transition: 'stroke-dashoffset 600ms ease-out 200ms'
                }}></path></svg></span> &nbsp;Innovation</h2>

            <p className="text-base text-muted-foreground mb-10 leading-normal max-w-2xl">MS Biotechnology connects innovative medical technologies with the right partners and markets. By combining global sourcing expertise, product evaluation, and strategic partnerships, we help transform innovative ideas into meaningful business opportunities.

Together with manufacturers, healthcare professionals, and distribution partners, we create long-term collaborations that advance healthcare innovation and deliver lasting value worldwide.</p>

            <ul className="space-y-6 mb-10">
              {promises.map((promise, i) => {
              const Icon = promise.icon;
              return <li data-index={i} key={i} className="group">
                    <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-smooth">
                      <div className="flex items-start gap-5">
                        <div className={`relative w-14 h-14 ${promise.stickerBg} rounded-lg border border-slate-200 flex items-center justify-center shrink-0`}>
                          <Icon className="w-7 h-7 text-blue-900" strokeWidth={2} />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center justify-between gap-4 mb-2">
                            <h3 className="font-default font-semibold text-blue-950 text-xl">
                              {promise.title}
                            </h3>
                            <Badge variant="secondary">{promise.metric}</Badge>
                          </div>
                          <p className="font-default text-base text-muted-foreground leading-normal">
                            {promise.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </li>;
            })}
            </ul>
            <Button asChild size="lg">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}